import {keys} from 'ts-transformer-keys';

import {DataObjects} from '~/shared/src/utilities/action';
import {Message} from '~/shared/src/utilities/message';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type Validator = {
    id : number;
    key : string;
    name : string;

    function? : string;
    order : number;
    dataObjects : DataObjects;
    message? : Message;
};
export const validatorProps = keys<Validator>();
export const requiredValidatorProps = keys<RequiredOf<Validator>>();
